
export const CONTACT_ORDER_METRIC = [
  {
    NAME:"CONTACT_PROFILE.ORDER_TAB.METRIC.ORDER",
    KEY:"total_order",
    DESC:"( total )",
  },
  {
    NAME:"CONTACT_PROFILE.ORDER_TAB.METRIC.COMPLETED",
    KEY:"total_completed",
    DESC:"( total )",
  },
  {
    NAME:"CONTACT_PROFILE.ORDER_TAB.METRIC.AMOUNT",
    KEY:"total_amount",
    DESC:"( total )",
  },
]

export const APPOINTMENT_BY_CONTACT_STATUS = [
    {id:0,title: 'CONTACT_PROFILE.APPOINTMENT_TAB.TABLE.STATUS.ACTIVE'},
    {id:1,title: 'CONTACT_PROFILE.APPOINTMENT_TAB.TABLE.STATUS.CANCELLED'},

]